module.exports = __webpack_public_path__ + "img/menu-bg2.853e193d.webp";